import React from 'react'
import { FallbackLoadingStyle } from './style'
import { LoadingOutlined } from '@ant-design/icons';
export const FallbackLoading = () => {
  return (
    <FallbackLoadingStyle>
      <div className="container_" id="only-class-loading">
        <LoadingOutlined />
      </div>
    </FallbackLoadingStyle>
  )
}
